/**
 * NotificationHandler Component
 *
 * Subscribes to Matrix events via useNotificationEvents hook to trigger
 * browser notifications when appropriate.
 *
 * Permission is NOT requested on page load. Instead, when a notification
 * would be shown and permission is 'default', the NotificationContext
 * shows an in-app banner prompting the user to enable notifications.
 * This "primed permission" approach improves UX by asking after users
 * understand why notifications are valuable (after receiving a message).
 *
 * This component must be rendered inside MatrixClientProvider to have access to the client.
 */

import { useNotificationEvents } from '../hooks/useNotificationEvents';

export const NotificationHandler = () => {
  // Subscribe to Matrix events and trigger notifications when appropriate
  useNotificationEvents();

  // Render a hidden marker to ensure React executes this component
  return <div data-component="notification-handler" style={{ display: 'none' }} />;
};

export default NotificationHandler;
